import { Link } from "react-router-dom";

const LINKS = [
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/ai-limitations", label: "AI & Evidence Limitations" },
  { to: "/data-deletion", label: "Data Deletion" },
  { to: "/acceptable-use", label: "Acceptable Use" },
  { to: "/help", label: "Contact" },
];

export function SiteFooter({ className = "" }) {
  const year = new Date().getFullYear();
  return (
    <footer className={`border-t border-[#E2E8F0] bg-white ${className}`} data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="Legal">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              className="text-sm text-[#475569] hover:text-brand font-medium">
              {l.label}
            </Link>
          ))}
        </nav>
        <p className="mt-4 text-sm text-[#94A3B8]">© {year} TenantSeal</p>
        <p className="mt-1 text-xs text-[#94A3B8]">TenantSeal provides documentation tools, not legal advice.</p>
      </div>
    </footer>
  );
}
